// The three global fields power-up effects write and the rest of the sim
// reads — the original's `globalSpeedFactor`, `_bugSpawnRate` and `_bugsFrozen`
// on `BugsModel` (plan 16 §3). A plain mutable record owned by `World`, created
// before both managers: it is what keeps `BugManager` and `PowerUpManager` from
// needing each other for these (the kill-half effect needs `BugManager`, so
// that dependency cannot go both ways).
//
// Pure data: no WebGL, no DOM (00-architecture.md §1).

/** Written by power-up effects, read by the bug and spawner systems. */
export interface GlobalModifiers {
  /**
   * Multiplies every walker's top speed alongside the level's `SpeedFactor` —
   * 0.5, 1 or 2. The speed effects *assign* it (never multiply), so two
   * half-speeds in a row still give 0.5x and half-then-double cancels.
   */
  speedFactor: number;
  /** Divides the spawn interval — 1 or 2 (`TimeUntilNextSpawn /= _bugSpawnRate`). */
  spawnRate: number;
  /**
   * Halts every bug whose kind has `affectedByFreeze` (all but black).
   * CORRECTION: checked per bug per step rather than stamped onto each bug as
   * the original's `CheckBugsFreeze` does — there, bugs spawned during the
   * 15 s window are never frozen (see `DIVERGENCES.md`).
   */
  frozen: boolean;
}

export function createModifiers(): GlobalModifiers {
  return { speedFactor: 1, spawnRate: 1, frozen: false };
}
